import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { name: "首页", path: "/" },
  { name: "同人小说", path: "/xiaoshuo" },
  { name: "同人图·壁纸", path: "/tongrentu" },
  { name: "短篇速读", path: "/duanpian" },
  { name: "关于我们", path: "/guanyu" },
];

interface NavbarProps {
  overlay?: boolean;
}

export default function Navbar({ overlay = false }: NavbarProps) {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const transparent = overlay && !scrolled;
  const solid = !transparent;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6 py-3">
        {/* 品牌 */}
        <Link to="/" className="flex items-center gap-2 group" aria-label="影页社 首页">
          <span className={`grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50 ${transparent ? "" : "shadow-soft"}`}>
            <i className="ri-quill-pen-fill text-lg"></i>
          </span>
          <span className="leading-none">
            <span className={`block font-display text-xl md:text-2xl ${transparent ? "text-background-50" : "text-foreground-950"}`}>
              影页社
            </span>
            <span className={`block font-label text-[10px] tracking-widest ${transparent ? "text-background-100/80" : "text-secondary-700"}`}>
              火影忍者同人图文站
            </span>
          </span>
        </Link>

        {/* 桌面导航 */}
        <ul className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => {
            const active = item.path === "/" ? pathname === "/" : pathname.startsWith(item.path);
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`relative rounded-md px-4 py-2 font-label text-sm whitespace-nowrap transition-colors ${
                    active
                      ? transparent
                        ? "text-primary-300"
                        : "text-primary-700 bg-primary-100/70"
                      : transparent
                        ? "text-background-50/90 hover:text-background-50"
                        : "text-foreground-700 hover:text-primary-700 hover:bg-secondary-100/60"
                  }`}
                >
                  {item.name}
                  {active && (
                    <span className={`absolute left-1/2 -translate-x-1/2 top-full h-0.5 w-6 rounded-full ${transparent ? "bg-primary-300" : "bg-primary-500"}`}></span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center gap-2">
          <Link
            to="/tongrentu"
            className={`hidden sm:inline-flex items-center gap-1 rounded-full px-4 py-2 font-label text-sm whitespace-nowrap transition-colors ${
              transparent
                ? "bg-background-50 text-foreground-950 hover:bg-primary-200"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className="ri-download-2-line"></i> 壁纸精选
          </Link>
          {/* 移动端汉堡 */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className={`grid h-10 w-10 place-items-center rounded-md md:hidden ${
              transparent ? "text-background-50 bg-background-950/20" : "text-foreground-900 bg-secondary-100"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md">
          <ul className="px-4 py-3 space-y-1">
            {navItems.map((item) => {
              const active = item.path === "/" ? pathname === "/" : pathname.startsWith(item.path);
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center justify-between rounded-md px-4 py-3 font-label text-base ${
                      active ? "bg-primary-100 text-primary-800" : "text-foreground-800 hover:bg-secondary-100"
                    }`}
                  >
                    {item.name}
                    {active && <i className="ri-check-line text-primary-600"></i>}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </header>
  );
}